



import { Component, Prop, Vue } from "vue-property-decorator";
import { BehaviorEnum } from "@/services/posts/types";
import { FILEENDPOINT } from "@/app.config";
import { Position } from "@/services/posts/postTypes/image";

@Component
export default class ImageSubRender extends Vue {
    @Prop() imagePath!: string;
    @Prop() imageName!: string;
    @Prop() behavior!: string;
    @Prop() position!: Position;
    @Prop() imageStyle!: string;
    @Prop() private containerHeight!: number;
    @Prop() private containerWidth!: number;
    @Prop() lastModifiedDate!: Date;

    // lifecycle hooks
    public mounted(): void {
        this.loadImage();
    }

    // computed
    get imageUrl(): string {
        if (this.behavior === BehaviorEnum.crop || this.behavior === BehaviorEnum.adjust) {
            return `${FILEENDPOINT}${this.imagePath}?date=${this.lastModifiedDate}}`;
        }

        let url = `${FILEENDPOINT}${this.imagePath}/${this.containerHeight}/${this.containerWidth}?date=${this.lastModifiedDate}`;
        if (this.behavior !== "letterBox") {
            url += `/false`;
        }

        return url;
    }

    // methods
    loadImage() {
        const staticImage = this.$refs.image as HTMLImageElement;
        const nameParts = this.imageName.split(".");
        const extension = nameParts[nameParts.length - 1];

        if (extension.toLowerCase() === "svg" && this.behavior !== BehaviorEnum.crop && this.behavior !== BehaviorEnum.adjust) {
            staticImage.width = this.containerWidth;
            staticImage.height = this.containerHeight;
        }

        // Reset some styles that might ruin the preview and let the css take over
        staticImage.style.top = "";
        staticImage.style.left = "";
        staticImage.style.right = "";
        staticImage.style.bottom = "";
        staticImage.style.position = "";
        staticImage.style.margin = "";
        if (this.behavior === BehaviorEnum.adjust) {
            staticImage.onload = () => {
                if (this.position.cropSizeHeight && this.position.cropSizeWidth && this.position.factor) {
                    const ratio = Math.max(this.containerWidth / staticImage.width, this.containerHeight / staticImage.height);
                    const ratio2 = Math.max((this.containerWidth * this.position.factor) / this.position.cropSizeWidth, (this.containerHeight * this.position.factor) / this.position.cropSizeHeight);
                    if (this.containerWidth === this.position.channelWidth && this.containerHeight === this.position.channelHeight) {
                        staticImage.style.transform = `scale(${ratio * ratio2})`;
                        staticImage.style.marginLeft = (-this.position.x * ratio2) + "px";
                        staticImage.style.marginTop = (-this.position.y * ratio2) + "px";
                    } else {
                        staticImage.style.width = this.containerWidth + "px";
                        staticImage.style.height = this.containerHeight + "px";
                        staticImage.style.objectFit = "cover";
                    }
                    staticImage.style.display = "block";
                }
            };
        }
        if (this.behavior === BehaviorEnum.crop) {
            staticImage.onload = () => {
                var ratio = Math.max(this.containerWidth / staticImage.width, this.containerHeight / staticImage.height);
                if (ratio < 1) {
                    console.log(ratio);
                    staticImage.style.transform = `scale(${ratio}) translate(-50%, -50%)`;
                }
            };
        }
        staticImage.src = this.imageUrl;
    }
}
